import { z } from "zod";
export const Id = z.uuid().meta({ id: "Id", description: "UUIDv7 identifier" });
export const Slug = z
    .string()
    .max(120)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
    .meta({ id: "Slug", description: "Lower-case URL slug" });
//# sourceMappingURL=ids.js.map